export default theme => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    gap: 8,
    width: '100%',
    '& > [class*="InputWrapper__root"]': {
      maxWidth: 'calc(100% - 96px)'
    },
    '& [class*="InputWrapper__formControl"]': {
      width: '100%'
    },
    '& [class*="HoiPoi__RichText__editor"]': {
      transition: 'initial'
    },
    '& [class*="HoiPoi__CopilotClearButton"], & [class*="HoiPoi__CopilotSpeechButton"]': {
      marginBottom: 8
    }
  }
});